import R from 'ramda';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { Modal, Form, FormGroup, FormControl } from 'react-bootstrap';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import logo from '../../assets/priori-legal.png';

class InviteOther extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullName: '',
      email: '',
      attorney: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { status, invite } = nextProps;

    if (this.props.status !== status) {
      if (status === actionTypes.INVITE_CREATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      } else if (status === actionTypes.INVITE_CREATE_SUCCESS && invite) {
        this.close();
      }
    }
  }

  opened = () => {
    this.setState({
      fullName: '',
      email: '',
      attorney: true,
    });
  };

  close = () => {
    this.props.onClose();
  };

  save = (e) => {
    const { fullName, email, attorney } = this.state;

    e.preventDefault();
    this.props.hideAlert();

    if (this.props.type === 'create-deal') {
      this.props.onSave({
        name: fullName,
        email: email,
        type: attorney === true ? 'attorney' : 'other',
      });

      this.props.onClose();
    } else {
      const { deal, profile, invites } = this.props;

      const index = R.findIndex(R.propEq('email', email))(invites);

      if (index === -1 && profile.email !== email) {
        let inviteData = [
          {
            deal: deal.id,
            inviter: profile.id,
            inviter_name: profile.name,
            name: fullName,
            email: email,
            type: attorney === true ? 'attorney' : 'other',
          },
        ];

        this.props.createInvite(deal.id, inviteData);
      } else {
        this.props.alert('error', 'You have already invited this person.');
      }
    }
  };

  handleChange(e, type) {
    this.setState({ [type]: e.target.value });
  }

  render() {
    const { fullName, email } = this.state;

    return (
      <Modal
        className="invite-other-modal"
        show={this.props.show}
        onEnter={this.opened}
        onHide={this.close}
      >
        <Modal.Header closeButton>
          <Modal.Title>Invite An Attorney</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Invite your attorney to review/redline this agreement. Only
            attorneys are permitted to redline this agreement.
          </p>
          <Form onSubmit={this.save}>
            <FormGroup>
              <FormControl
                ref="fullName"
                type="text"
                placeholder="Their Full Name"
                value={fullName}
                onChange={(e) => this.handleChange(e, 'fullName')}
                required
              />
            </FormGroup>
            <FormGroup>
              <FormControl
                ref="email"
                type="email"
                placeholder="Their Email Address"
                required
                value={email}
                onChange={(e) => this.handleChange(e, 'email')}
              />
            </FormGroup>
            {/* <FormGroup>
              <Checkbox checked={this.state.attorney} onChange={(e) => this.setState({ attorney: e.target.checked })}>
                This person is an attorney
              </Checkbox>
            </FormGroup> */}
            <FormGroup className="text-center">
              <button
                type="submit"
                disabled={
                  this.props.status === actionTypes.INVITE_CREATE_REQUEST
                }
              >
                {this.props.status === actionTypes.INVITE_CREATE_REQUEST && (
                  <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
                )}
                Send
              </button>
            </FormGroup>
          </Form>
          <p>
            Don't have an attorney, but wish to use one? Our friends at Priori
            Legal can connect to you vetted, qualified attorneys at affordable
            rates. Click on the link below to get started.
          </p>
          <div className="text-center">
            <Link
              to="https://www.priorilegal.com/cosynd-VYqUp8mlcijiwrNykTnulg"
              target="_blank"
            >
              <img src={logo} className="logo" alt="Priori Legal" />
            </Link>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  deal: state.deals.selectedDeal,
  status: state.invites.status,
  invite: state.invites.selectedInvite,
  invites: state.invites.invites,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadDeal: (dealId) => {
    dispatch(actions.getDeal(dealId));
  },
  createInvite: (dealId, invite) => {
    dispatch(actions.createInvite(dealId, invite));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteOther);



// WEBPACK FOOTER //
// src/components/Deals/InviteOther.jsx